import axiosInstance from '../axiosInterceptor/axiosInstance'

const postGameForfeit = async ({ orgId, gameId, forfeitingEventTeamId, reason, scores }) => {
  const url = `v1/orgs/${orgId}/games/${gameId}/stats/forfeit`
  const body = { forfeitingEventTeamId, reason }
  if (scores) body.scores = scores
  const response = await axiosInstance.post(url, body)
  return response?.data
}

export default postGameForfeit
